import { message } from 'antd';

export const successGoogleCalendar = async () => {
    message.success('Ваши занятия добавлены в Google Calendar');
};

export const infoGoogleCalendar = async () => {
     message.info('Нет новых событий');
};

